/* eslint-disable no-mixed-spaces-and-tabs */
/* eslint-disable react/jsx-wrap-multilines */
import React, { useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import { useHistory, useLocation } from 'react-router';
import { useInjectSaga } from '../../utils/injectSaga';
import saga from './saga';
import { useInjectReducer } from '../../utils/injectReducer';
import reducer from './reducer';
import { getAutoparksTransportsAction } from './actions';
import {
	getAutoparksTransportsSelector,
	getIsAutoparksTransportsLoadingSelector,
	getPaginationSelector,
} from './selectors';
import { TABLE_COLUMNS } from './constants';
import { normalizeDataGridModel } from '../../utils/normalizeDataGridModel';
import { DataGridComponent } from '../../components/data-grid';

const AutoparksTransportsContainerWrapper = ({
	onGetAutoparksTransports,
	autoparksTransports,
	isAutoparksTransportsLoading,
}) => {
	useInjectSaga({ key: 'autoparksTransportsSaga', saga });
	useInjectReducer({ key: 'autoparksTransportsReducer', reducer });

	const { search, pathname } = useLocation();

	const query = new URLSearchParams(search);

	const history = useHistory();

	const autoparkId = query.get('id');

	useEffect(() => {
		if (autoparkId) {
			onGetAutoparksTransports({ searchQuery: query.toString(), autoparkId });
		}
	}, [autoparkId]);

	const handleSortChange = useCallback(sortModel => {
		const jsonSorts = JSON.stringify(sortModel);

		query.set('childrenSorts', jsonSorts);

		history.push(`${pathname}?${query}`);
		onGetAutoparksTransports({ searchQuery: query.toString(), autoparkId });
	});

	const handleFilterChange = useCallback((filterModel, action) => {
		if (action.reason) {
			const jsonFilters = JSON.stringify(normalizeDataGridModel(filterModel, TABLE_COLUMNS()));

			query.set('childrenFilters', jsonFilters);

			history.push(`${pathname}?${query}`);
			onGetAutoparksTransports({ searchQuery: query.toString(), autoparkId });
		}
	});

	return (
		<DataGridComponent
			columns={TABLE_COLUMNS()}
			rows={autoparksTransports}
			isTableDataLoading={isAutoparksTransportsLoading}
			pagination={null}
			isChildren
			isWithoutFooter
			handleSortChange={handleSortChange}
			handleFilterChange={handleFilterChange}
			filterKey="childrenFilters"
			sortKey="childrenSorts"
		/>
	);
};

const mapStateToProps = createStructuredSelector({
	autoparksTransports: getAutoparksTransportsSelector(),
	pagination: getPaginationSelector(),
	isAutoparksTransportsLoading: getIsAutoparksTransportsLoadingSelector(),
});

const mapDispatchToProps = {
	onGetAutoparksTransports: getAutoparksTransportsAction,
};

AutoparksTransportsContainerWrapper.propTypes = {
	onGetAutoparksTransports: PropTypes.func.isRequired,
	autoparksTransports: PropTypes.array.isRequired,
	isAutoparksTransportsLoading: PropTypes.bool.isRequired,
	pagination: PropTypes.shape({
		currentPage: PropTypes.number,
		totalPages: PropTypes.number.isRequired,
		total: PropTypes.number,
		from: PropTypes.number,
		to: PropTypes.number,
		isNextItem: PropTypes.bool,
		isPrevItem: PropTypes.bool,
		isFirstItem: PropTypes.bool,
		isLastItem: PropTypes.bool,
	}),
};

const AutoparksTransportsContainer = connect(mapStateToProps, mapDispatchToProps)(AutoparksTransportsContainerWrapper);

export { AutoparksTransportsContainer };
